import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { setUnlockMatrixWeekModalOpen } from "../../../reducers/ownApp";
import { forceUnlockMatrixWeek } from "../../../reducers/driverManagement/thunkActions";
import { unlockMatrixWeekModalOpenSelector } from "../../../reducers/ownApp/selectors";

import { Modal } from "../Modal";
import { UnlockMatrixWeekModalActions } from "./UnlockMatrixWeekModalActions";

const useStyles = makeStyles({
  text: {
    fontSize: "16px",
    lineHeight: "20px",
    marginTop: "10px",
  },
});

const UnlockMatrixWeekModal = () => {
  const dispatch = useDispatch();

  const classes = useStyles();
  const modalOpen = useSelector(unlockMatrixWeekModalOpenSelector);

  const closeClick = () => {
    dispatch(setUnlockMatrixWeekModalOpen(false));
  };

  const continueCLick = () => {
    dispatch(setUnlockMatrixWeekModalOpen(false));
    dispatch(forceUnlockMatrixWeek());
  };

  return (
    <>
      <Modal
        maxWidth={"xs"}
        open={modalOpen}
        onClose={closeClick}
        title={`Unlock Drivers Week`}
        content={
          <>
            <Typography className={classes.text}>
              Are you sure you wish to unlock all drivers, routes and daily
              plans in the selected depot?
            </Typography>
            <Typography className={classes.text}>
              If you continue, this will remove the locks from all daily plans
              records in this depot and these users will lose any unsaved driver
              and plan changes.
            </Typography>
          </>
        }
        actions={
          <UnlockMatrixWeekModalActions
            onCancel={closeClick}
            onContinue={continueCLick}
          />
        }
        minWidth={500}
      />
    </>
  );
};

export default UnlockMatrixWeekModal;
